export default __webpack_public_path__ + "static/media/contact.df3f34a0.png";